module.exports = __webpack_public_path__ + "img/D4.56525262.svg";